export default "__VITE_ASSET__9444f9de__"